<script setup lang="ts">
import {Popover, PopoverContent, PopoverTrigger} from "@/core/components/ui/popover";
import {Button} from "@/core/components/ui/button";
import {cn} from "@/lib/utils";
import {Calendar} from '@lucide/vue';
import MultiDatePicker from "@/core/components/date-picker/MultiDatePicker.vue";
import {computed} from "vue";
import {CalendarDate, DateValue} from "@internationalized/date";
import {DosageFormData} from "@/dosage/interfaces/DosageForm";

const dates = defineModel<DosageFormData['dates']>({required: true});

const calendarDates = computed({
    get: (): DateValue[] => {
        return dates.value?.map(date => {
            return new CalendarDate(date.value.getFullYear(), date.value.getMonth() + 1, date.value.getDate());
        }) ?? [];
    },
    set: (val: Date[] | null) => {
        if (!val || !val?.length) {
            dates.value = null;
            return;
        }

        dates.value = val.map(d => ({value: new Date(d.toString())}))
            .sort((a, b) => a.value.getTime() - b.value.getTime());
    }
});
</script>

<template>
  <Popover modal>
    <PopoverTrigger>
      <Button
        variant="outline"
        :class="cn(
          'w-auto justify-start text-left font-normal flex'
        )"
      >
        Configurer dans le calendrier
        <Calendar class="h-4 w-4" />
      </Button>
    </PopoverTrigger>
    <PopoverContent>
      <MultiDatePicker v-model:model-value="calendarDates" />
    </PopoverContent>
  </Popover>
</template>

<style scoped>

</style>
